"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _lodash = require("lodash");
var _reactRouterDom = require("react-router-dom");
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _reactI18next = require("react-i18next");
var _clsx = _interopRequireDefault(require("clsx"));
var _image6 = _interopRequireDefault(require("../../helper/image"));
var _resolvePath = _interopRequireDefault(require("../../utils/resolvePath"));
var _resolveImage = _interopRequireDefault(require("../../utils/resolveImage"));
var _bookmarkIcon = _interopRequireDefault(require("../bookmark-icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "block",
    position: "relative"
  },
  hasImage: {
    "&::before": {
      background: "rgba(45, 52, 62, 0.4)",
      content: "''",
      height: "100%",
      left: 0,
      position: "absolute",
      top: 0,
      width: "100%",
      zIndex: theme.zIndex.image.overlay
    }
  },
  noImageLayer: {
    background: theme.palette.primary.light,
    height: 200,
    position: "relative",
    width: "100%"
  },
  image: {
    display: "block",
    height: 180,
    objectFit: "cover",
    width: "100%",
    zIndex: theme.zIndex.default,
    [theme.breakpoints.up("sm")]: {
      minHeight: 180
    },
    [theme.breakpoints.up("md")]: {
      height: "100%",
      minHeight: 0,
      maxHeight: 428
    }
  },
  noImage: {
    display: "block",
    height: 180,
    objectFit: "cover",
    width: "100%"
  },
  logo: {
    display: "block",
    left: "50%",
    maxHeight: 80,
    maxWidth: 80,
    position: "absolute",
    top: "50%",
    transform: "translate(-50%, -50%)"
  },
  title: {
    alignItems: "center",
    color: theme.palette.foreground.overlay,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100%",
    left: theme.spacing(2),
    margin: 0,
    position: "absolute",
    right: theme.spacing(2),
    textAlign: "center",
    textTransform: "uppercase",
    top: 0,
    zIndex: theme.zIndex.image.content
  },
  addition: {
    lineHeight: 1.2,
    margin: theme.spacing(1, 0, 0)
  },
  date: {
    background: theme.palette.primary.main,
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(0.5)
  },
  mark: {
    alignItems: "center",
    background: theme.palette.primary.main,
    borderRadius: "50%",
    color: theme.palette.foreground.overlay,
    display: "flex",
    height: theme.spacing(6),
    justifyContent: "center",
    lineHeight: theme.spacing(6),
    position: "absolute",
    right: theme.spacing(2),
    textTransform: "uppercase",
    top: theme.spacing(2),
    width: theme.spacing(6),
    zIndex: theme.zIndex.image.content
  },
  bookmark: {
    zIndex: theme.zIndex.image.content
  }
}));
const ThemeTeaser = _ref => {
  let {
    data,
    marginY,
    mediaFormat,
    showBookmark
  } = _ref;
  const {
    teaser
  } = data;
  const {
    link
  } = teaser;
  const css = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: marginY
  }, link ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: (0, _clsx.default)({
      [css.root]: true,
      [css.hasImage]: !!(teaser !== null && teaser !== void 0 && teaser.media.length)
    }),
    to: link
  }, /*#__PURE__*/_react.default.createElement(ThemeTeaserItemContent, {
    data: teaser,
    mediaFormat: mediaFormat,
    showBookmark: showBookmark
  })) : /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: (0, _clsx.default)({
      [css.root]: true,
      [css.hasImage]: !!(teaser !== null && teaser !== void 0 && teaser.media.length)
    })
  }, /*#__PURE__*/_react.default.createElement(ThemeTeaserItemContent, {
    data: teaser,
    mediaFormat: mediaFormat,
    showBookmark: showBookmark
  })));
};
const ThemeTeaserItemContent = _ref2 => {
  let {
    data,
    mediaFormat,
    showBookmark
  } = _ref2;
  const {
    id,
    type,
    title,
    addition,
    media,
    from,
    to,
    timeFrom,
    timeTo,
    marks
  } = data;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, media && /*#__PURE__*/_react.default.createElement(ThemeTeaserImage, {
    media: (0, _lodash.first)(media),
    mediaFormat: mediaFormat
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: css.title
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "span",
    dangerouslySetInnerHTML: {
      __html: title
    },
    variant: "h2"
  }), addition && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.addition,
    component: "span",
    dangerouslySetInnerHTML: {
      __html: addition
    },
    variant: "body2"
  }), (from || to) && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.date,
    variant: "overline",
    component: "span"
  }, from && (0, _moment.default)(from).format("L"), from && to && " - ", to && (0, _moment.default)(to).format("L")), (timeFrom || timeTo) && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.date,
    variant: "overline",
    component: "span"
  }, timeFrom && (0, _moment.default)(timeFrom).format("LT"), timeFrom && timeTo && timeFrom !== timeTo ? " - ".concat((0, _moment.default)(timeTo).format("LT")) : "")), marks && /*#__PURE__*/_react.default.createElement("div", {
    className: css.mark
  }, t("site.ui.label.tip")), showBookmark && /*#__PURE__*/_react.default.createElement(_bookmarkIcon.default, {
    id: id,
    type: type,
    addition: addition,
    title: title,
    link: window.location.pathname
  }));
};
const ThemeTeaserImage = _ref3 => {
  var _image, _image2, _image3, _image4, _image5;
  let {
    media,
    mediaFormat = "theme-teaser"
  } = _ref3;
  const css = useStyles();
  let image = null;
  if (media !== null && media !== void 0 && media.subFormats) {
    image = (0, _lodash.first)((0, _resolveImage.default)(media === null || media === void 0 ? void 0 : media.subFormats, mediaFormat));
  }
  if (!image) {
    image = media;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, image ? /*#__PURE__*/_react.default.createElement(_image6.default, {
    itemStyle: css.image,
    filename: ((_image = image) === null || _image === void 0 ? void 0 : _image.filename) && (0, _resolvePath.default)((_image2 = image) === null || _image2 === void 0 ? void 0 : _image2.filename) + ((_image3 = image) === null || _image3 === void 0 ? void 0 : _image3.filename),
    height: (_image4 = image) === null || _image4 === void 0 ? void 0 : _image4.height,
    width: (_image5 = image) === null || _image5 === void 0 ? void 0 : _image5.width,
    alt: media === null || media === void 0 ? void 0 : media.alt
  }) : /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: css.noImageLayer
  }));
};
ThemeTeaser.defaultProps = {
  marginY: 4,
  showBookmark: false
};
var _default = exports.default = ThemeTeaser;